import { useEffect } from 'react';

// Marks a scroller with data-more-above / data-more-below so CSS can fade
// only the edges that actually hide text (the Buffy chat transcripts).
export default function useScrollEdges(ref, active) {
  useEffect(() => {
    const scroller = ref.current;
    if (!active || !scroller) return undefined;
    const update = () => {
      scroller.dataset.moreAbove = String(scroller.scrollTop > 3);
      scroller.dataset.moreBelow = String(scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 3);
    };
    update();
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    observer?.observe(scroller);
    const mutations = typeof MutationObserver !== 'undefined' ? new MutationObserver(update) : null;
    mutations?.observe(scroller, { childList: true, subtree: true, characterData: true });
    return () => {
      scroller.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      observer?.disconnect();
      mutations?.disconnect();
    };
  }, [ref, active]);
}
